
<template>
  <v-dialog v-if="isSuperAdmin"
            v-model="open"
            width="unset">
    <template v-slot:activator="{ on, attrs }">
      <v-btn @click="open = !open"
             v-bind="attrs"
             v-on="on"
             class="footerbtn second"
             dark
             icon>
        <v-icon size="18"
                class="d-flex align-self-center"
                v-text="'mdi-file-find'" />
      </v-btn>
    </template>

    <v-card class="pa-4 overlay-scroll"
            width="auto">
      <h3 v-text="'Favorites'" />
      <div v-if="favorites.length < 1">No favorites</div>
      <recurrsive-object-print v-for="(value, key, index) in favorites"
                               :key="`favorites-${ key }-${ index }`"
                               :keyname="value"
                               :value="byString($store.state, value)"
                               :keypath="value"
                               :favorites="favorites"
                               @Update="favoriteToggle">
      </recurrsive-object-print>
      <br>
      <h3 v-text="'Store'" />
      <recurrsive-object-print v-for="(value, key, index) in $store.state"
                               :key="`${ key }-${ index }`"
                               :keyname="key"
                               :value="value"
                               :keypath="key"
                               :favorites="favorites"
                               @Update="favoriteToggle">
      </recurrsive-object-print>
    </v-card>
  </v-dialog>
</template>


<script>
import RecurrsiveObjectPrint from "@/components/SingleUse/RecurrsiveObjectPrint.vue";

export default {
  name: "StoreInspector",
  props: [],
  components: { RecurrsiveObjectPrint },

  data() {
    return {
      open: false,
      favorites: [],
    };
  },

  mounted() {
    var stored = JSON.parse(localStorage.getItem("StoreInspectorFavorites" || false));
    if (stored != null && stored != undefined) {
      this.favorites = stored;
    } else {
      this.favorites = [];
    }
  },

  methods: {
    favoriteToggle(update) {
      if (!update.value) {
        var target = update.key;
        this.favorites = this.favorites.filter(function (x) {
          return x != target;
        });
      } else {
        this.favorites.unshift(update.key);
      }
    },

    byString(object, keystring) {
      keystring = keystring.replace(/\[(\w+)\]/g, ".$1");
      keystring = keystring.replace(/^\./, "");
      var splitarray = keystring.split(".");
      for (var i = 0; i < splitarray.length; ++i) {
        var key = splitarray[i];
        if (object && key in object) {
          object = object[key];
        } else {
          return;
        }
      }
      return object;
    },
  },

  computed: {},

  watch: {
    favorites: function () {
      localStorage.setItem("StoreInspectorFavorites", JSON.stringify(this.favorites));
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay-scroll {
  max-height: 80vh;
  overflow-y: overlay;
}
@-moz-document url-prefix() { //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .overlay-scroll {
    overflow-y: auto;
  }
}
</style>